import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import classnames from 'classnames';

import type { FieldStatus } from 'app/components/FormField';

import style from './style.scss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type?: 'text' | 'email' | 'password' | 'number';
  status?: FieldStatus;
  suffix?: string;
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ status, type = 'text', suffix, className, error, ...props }, ref) => {
    const inputClassName = classnames(style.input, className, {
      [style.input_valid]: status === 'VALID',
      [style.input_invalid]: status === 'INVALID',
      [style.input_withSuffix]: !!suffix,
      [style.input_error]: error
    });

    return (
      <>
        <input ref={ref} type={type} className={inputClassName} {...props} />
        {suffix && <span className={style.suffix}>{suffix}</span>}
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
export type { InputProps };
